<template>
  <div class="card upcomingtabs">
    <v-row justify="center" align="center" class="mx-0 mx-md-0">
      <v-sheet
        elevation="0"
        class="px-5 py-4 text-center box-shadownon bgnone col-12"
        rounded
        v-for="item in upcomingGame"
        :key="item._id"
      >
        <p class="subtitle-1 mt-3 mt-md-0 px-3 px-md-0">
          Upcoming Game:
          <strong class="blue--text">Next Game:</strong>&nbsp;
          <!-- <router-link :to="{ name: 'OptimizerTab' }" class="href"></router-link> -->
          <span style="vertical-align: middle">
            {{ item.DateTime | IsoToIst }} EST Vs. {{ item.AwayTeam }}
          </span>

          <!-- <span
            v-if="sportsType && sportsType == 'MLB'"
            style="vertical-align:middle"
          >
            {{ item.DateTime | IsoToIst }} EST Vs. Away Team ({{
              item.AwayTeam
            }})
          </span> -->
          <img
            style="vertical-align: middle; width: 35px; height: 35px"
            :src="oppLogo"
            alt="Logo"
          />
        </p>

        <!-- Game schedule.. -->
        <v-col cols="12" md="12" sm="12" class="px-0 px-md-3">
          <v-data-table
            dense
            :headers="headers"
            :items="nextGame"
            class="elevation-1 box-shadownon tabcontentcustom-bottom px-0 px-md-3"
            hide-default-footer
            mobile-breakpoint="0"
          >
            <!-- date time -->
            <template v-slot:item.dateAndTime="{ item }">
              <p v-if="sportsType && sportsType == 'MLB'" class="caption">
                {{ item.dateAndTime | dayFormat }} EST
              </p>

              <p v-else class="caption">
                {{ item.dateAndTime | IsoToIst }} EST
              </p>
            </template>
            <!-- date time -->

            <!-- game week -->
            <template v-slot:item.team="{ item }">
              <p class="caption">
                {{ item.Awayteam }} @
                <span class="black--text">{{ item.HomeTeam }}</span>
              </p>
            </template>
            <!-- game week -->
          </v-data-table>
        </v-col>
        <!-- Game schedule ends... -->
      </v-sheet>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "upcomingGame",
  props: {
    upcomingGame: {
      type: Array,
      default: [],
    },
    oppLogo: {
      type: String,
      default: "",
    },
    nextGame: {
      type: Array,
      default: () => [],
    },
    sportsType: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      headers: [
        {
          text: "Date and Time",
          value: "dateAndTime",
          sortable: false,
        },
        { text: "Game", value: "team" },
        {
          text: "Opponent Team",
          value: "oppTeam",
        },
        { text: "TV Channel", value: "tvChannel" },
      ],
    };
  },
};
</script>

<style scoped></style>
